import styled from 'styled-components';

const RoleButtonGroup = styled.div`
  button {
    height: min-content;
  }
`;

export { RoleButtonGroup };
